import { render, staticRenderFns } from "./VideosView.vue?vue&type=template&id=5ad7bec6&scoped=true&"
import script from "./VideosView.vue?vue&type=script&lang=ts&"
export * from "./VideosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7bec6",
  null
  
)

export default component.exports